module.exports = __webpack_public_path__ + "fonts/GothamSSm-BoldItalic.d051dc9a.woff";